import { render } from "./g-search-field.vue?vue&type=template&id=047d2b01&ts=true"
import script from "./g-search-field.vue?vue&type=script&lang=tsx"
export * from "./g-search-field.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__